import { useState } from 'react';
import './index.css';
import Loader from './components/Loader';
import Cursor from './components/Cursor';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Hero from './sections/Hero';
import About from './sections/About';
import Services from './sections/Services';
import Projects from './sections/Projects';
import Testimonials from './sections/Testimonials';
import Contact from './sections/Contact';

export default function App() {
  const [loading, setLoading] = useState(true);

  return (
    <>
      {loading && <Loader onDone={() => setLoading(false)} />}

      {/* Main site — hidden while loader is up, fades in after */}
      <div style={{
        opacity: loading ? 0 : 1,
        transition: 'opacity 0.6s ease 0.1s',
        pointerEvents: loading ? 'none' : 'auto',
      }}>
        <Cursor />
        <Navbar />
        <main>
          <Hero />
          <About />
          <Services />
          <Projects />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
      </div>
    </>
  );
}
